import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SideBar from "./SideBar";
import { ToggleButton } from "./SideBar"; // Import ToggleButton from SideBar
import { useBlogContext } from "../../fetchdata/BlogContext";
import { weburl } from "../../axiosInstance";
import toast from "react-hot-toast";
import PropTypes from "prop-types"; // Import PropTypes
import getCookie from "../../helper/getCookie";
import { useDispatch } from "react-redux";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import OtpList from "./OtpList";

const Header = () => {
  const dispatch = useDispatch();

  const { walletAmount, UserProfile, UserFullName } = useBlogContext();

  const [sidebarVisible, setSidebarVisible] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const [selectedLocation, setSelectedLocation] = useState("");

  useEffect(() => {
    const location = localStorage.getItem("selectedLocation");
    if (location) {
      setSelectedLocation(location);
    }
  }, []);

  const isLoginFromLocalStorage = getCookie("token") ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
    console.log('eveent', isLoginFromLocalStorage);
    if (UserProfile) {
      console.log('eveent', UserProfile.toString());

    }

  }, [isLoginFromLocalStorage, UserProfile]);



  return (
    <>
      <div className="dz-gradient-shape pt-2">
        {/* Header */}
        <header
          className="header py-2 mx-auto newhead"
        >
          <div className="header-content " style={{ minHeight: "auto" }}>
            <div >

              <div className="info w-100">

                <h4 className="title">Welcome {UserFullName && UserFullName !== '' ? UserFullName : 'User'}</h4>
                <p className="text m-b10" id="select-location">
                  <Link
                    to="/my-location"
                    className="m-0 overflowOne cursor  text-dark"
                  >
                    {" "}
                    <span className={`overflowOne ${!selectedLocation && 'text-danger'}`}>
                      {" "} <i className="ri-map-pin-2-fill" />{" "}
                      {selectedLocation ? selectedLocation : 'Select Location'}
                    </span>
                  </Link>
                </p>
              </div>


            </div>
            <div className="mid-content" >

            </div>

            <div className="right-content d-flex align-items-center gap-2">

              <Link to="/account">
                {isLogin && UserProfile ? (
                  UserProfile && UserProfile !== "" && (
                    <img
                      style={{ minWidth: 40, height: 40, borderRadius: "100%", objectFit: "cover" }}
                      src={UserProfile !== ""
                        ? weburl +
                        UserProfile.replace(/\\/g, "/").replace(/^public\//, "")
                        : "/assets/img/user.svg"}

                      onError={(e) => { e.target.src = '/assets/img/user.svg'; }}  // Set default image on error

                    />
                  )
                  //  : (

                  //   <div
                  //     src={UserProfile}
                  //     className="spinner-border spinner-border-lg"
                  //     role="status"
                  //   />
                  // )
                ) : (
                  <img
                    style={{ minWidth: 40, height: 40, borderRadius: "100%", objectFit: "cover" }}
                    src={
                      '/assets/img/user.svg'}

                  />
                )
                }


              </Link>



              <ToggleButton onClick={toggleSidebar} />


            </div>




          </div>
        </header>
        {/* Header */}
      </div>
      <div
        className={`sidebar-container ${sidebarVisible ? "visible" : "d-none"}`}
      >
        <SideBar isVisible={sidebarVisible} toggleSidebar={toggleSidebar} />
      </div>
      <OtpList/>
    </>
  );
};


Header.propTypes = {
  updateAuthStatus: PropTypes.bool.isRequired,
};


export default Header;
